export default "__VITE_ASSET__C3LfVW5Q__"